import { GroupedByBrandShelfTalkerCardData } from '../../../../shelf-talkers/grouped-by-brand-shelf-talker-card-data';
import { Type } from '@angular/core';
import { CardBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/card-background.component';
import { ShelfTalkerCardContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/shared/shelf-talker-card-content.component';
import { GlassHouseFiveBySevenBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/custom-cards-5x7/glass-house-five-by-seven-background/glass-house-five-by-seven-background.component';
import { GlassHouse5By7ShelfTalkerContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/custom-cards-5x7/glass-house-5-by-7-shelf-talker-content/glass-house-5-by-7-shelf-talker-content.component';
import { FiveBySevenShelfTalker } from './five-by-seven-shelf-talker';

export class GlassHouse5by7ShelfTalker extends FiveBySevenShelfTalker {
  getCardBackgroundComponent(data: GroupedByBrandShelfTalkerCardData): Type<CardBackgroundComponent> {
    return GlassHouseFiveBySevenBackgroundComponent;
  }

  getCardContentComponent(data: GroupedByBrandShelfTalkerCardData): Type<ShelfTalkerCardContentComponent> {
    return GlassHouse5By7ShelfTalkerContentComponent;
  }

  public nonPerforatedBleedBorderInInches(): number {
    return 0;
  }
}
